/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-avatar-filled-alt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm5 14.324v-.38a3.256 3.256 0 00-3.125-3.319h-3.75a3.25 3.25 0 00-3.119 3.319c0 .007-.006.013-.006.02v.366a7.503 7.503 0 1110-.006zM10 4.375a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25z"/>'
  }
})
